import TableText from "@/components/table/TableText";
import _ from 'lodash';
import moment from "moment";
import React from "react";
import { sum, calculation, numConvert } from '@/method';

const totalIndex = [3, 6, 10, 14, 15, 18, 22, 23, 27, 33, 34, 37];
const percentIndex = [37];
const nameList = ['actual', 'last', 'forecast', 'budget', 'vslast', 'vsforecast', 'vsbudget'];
const monthList = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec", 'full'];
const nameKeyLst = [
    { name: "TY Actual", key: "actual" },
    { name: "LY Actual", key: "last" },
    { name: "Forecast", key: "forecast" },
    { name: "Budget", key: "budget" },
    { name: "Actual TY vs. LY", key: "vslast" },
    { name: "Actual vs. Forecast", key: "vsforecast" },
    { name: "Actual vs. Budget", key: "vsbudget" },
    { name: "MIX% (RNTS)", key: "mixrn" },
    { name: "MIX% (REV)", key: "mixrev" },
];
const sumIndex = {
    3: [0, 1, 2],
    6: [4, 5],
    10: [7, 8, 9],
    14: [12, 13],
    15: [3, 6, 10, 11, 14],
    18: [16, 17],
    22: [19, 20, 21],
    23: [18, 22],
    27: [24, 25, 26],
    33: [28, 29, 30, 31, 32],
    34: [15, 23, 27, 28]
};

export const compute = (data, { budget, actual, forecast, month, year, last }) => {
    if (year <= 2024) {
        const index = (month - 1) * 3 + 1;
        const correspond = {
            0: "best",
            1: "packges",
            2: "commerce",
            5: "wholesale",
            8: "corporate",
            11: "government",
            12: "discounts",
            15: "total",
            16: "business",
            19: "leisure",
            23: "group_total",
            24: "contracts",
            31: "others",
            34: "grand",
        };
        Object.entries(correspond).forEach(item => {
            data[item[0]].last_rn = _.get(last, `${index}.${item[1]}_rn`, 0);
            data[item[0]].last_rev = _.get(last, `${index}.${item[1]}_rev`, 0);
        });
        data[35].last_rn = _.get(last, `${index}.grand_rms`, 0);
        data[36].last_rn = ~~(data[35].last_rn - data[34].last_rn);

        const rn = `last_rn`;
        const rev = `last_rev`;
        Object.entries(sumIndex).forEach(index => {
            data[index[0]][rn] = index[1].reduce((a, b) => a += numConvert(data[b][rn]), 0).toFixed(2);
            data[index[0]][rev] = [...index[1], ...(index[0] == 34 ? [31, 32] : [])].reduce((a, b) => a += numConvert(data[b][rev]), 0).toFixed(2);
        });
    }
    data.forEach((item, i) => {
        data[i].actual_rn = _.get(actual, `${i}.${monthList[~~(month - 1)]}_rn`, 0);
        data[i].actual_rev = _.get(actual, `${i}.${monthList[~~(month - 1)]}_rev`, 0);
        if (month > 1) {
            data[i].forecast_rn = _.get(forecast, `${i}.${monthList[~~(month - 1)]}_rn`, 0);
            data[i].forecast_rev = _.get(forecast, `${i}.${monthList[~~(month - 1)]}_rev`, 0);
        }
        data[i].budget_rn = _.get(budget, `${i}.${monthList[~~(month - 1)]}_rn`, 0);
        data[i].budget_rev = _.get(budget, `${i}.${monthList[~~(month - 1)]}_rev`, 0);
        if (year > 2024) {
            data[i].last_rn = _.get(last, `${i}.${monthList[~~(month - 1)]}_rn`, 0);
            data[i].last_rev = _.get(last, `${i}.${monthList[~~(month - 1)]}_rev`, 0);
        }
    });

    if (month == 1) {

        ['forecast_rn', 'forecast_adr', 'forecast_rev'].forEach(name => {
            Object.entries(sumIndex).forEach(index => {
                data[index[0]][name] = [...index[1], ...(name == 'forecast_rev' && index[0] == 34 ? [31, 32] : [])].reduce((a, b) => a += numConvert(data[b][name]), 0).toFixed(2);
            });
        });
    }

    nameList.forEach(name => {
        if (!name.includes('vs')) {
            data.forEach((item, i) => {
                data[i][`${name}_adr`] = calculation(item[`${name}_rev`], item[`${name}_rn`]);
            });
            data[37][`${name}_adr`] = calculation(data[34][`${name}_rev`], data[34][`${name}_rn`]);
            data[37][`${name}_rn`] = calculation(data[34][`${name}_rn`], data[35][`${name}_rn`], 4);
            data[37][`${name}_rev`] = (data[37][`${name}_adr`] * data[37][`${name}_rn`]).toFixed(2);
        }
    });

    data.forEach((item, i) => {
        data[i].vslast_rn = (item.actual_rn - item.last_rn).toFixed(2);
        data[i].vslast_adr = (item.actual_adr - item.last_adr).toFixed(2);
        data[i].vslast_rev = (item.actual_rev - item.last_rev).toFixed(2);
        data[i].vsforecast_rn = (item.actual_rn - item.forecast_rn).toFixed(2);
        data[i].vsforecast_rev = (item.actual_rev - item.forecast_rev).toFixed(2);
        data[i].vsforecast_adr = (item.actual_adr - item.forecast_adr).toFixed(2);
        data[i].vsbudget_rn = (item.actual_rn - item.budget_rn).toFixed(2);
        data[i].vsbudget_rev = (item.actual_rev - item.budget_rev).toFixed(2);
        data[i].vsbudget_adr = (item.actual_adr - item.budget_adr).toFixed(2);
    });

    data.forEach((item, i) => {
        if (i < 35) {
            data[i][`mixrn_rn`] = calculation(data[i][`actual_rn`], sum([data[34][`actual_rn`], data[30][`actual_rn`], data[29][`actual_rn`]]), 4);
            data[i][`mixrn_adr`] = calculation(data[i][`last_rn`], sum([data[34][`last_rn`], data[30][`last_rn`], data[29][`last_rn`]]), 4);
            data[i][`mixrn_rev`] = calculation(data[i][`budget_rn`], sum([data[34][`budget_rn`], data[30][`budget_rn`], data[29][`budget_rn`]]), 4);

            data[i][`mixrev_rn`] = calculation(data[i][`actual_rev`], sum([data[34][`actual_rev`], data[30][`actual_rev`], data[29][`actual_rev`]]), 4);
            data[i][`mixrev_adr`] = calculation(data[i][`last_rev`], sum([data[34][`last_rev`], data[30][`last_rev`], data[29][`last_rev`]]), 4);
            data[i][`mixrev_rev`] = calculation(data[i][`budget_rev`], sum([data[34][`budget_rev`], data[30][`budget_rev`], data[29][`budget_rev`]]), 4);
        }
    });
    data[36][`forecast_rn`] = ~~(data[35][`forecast_rn`] - data[34][`forecast_rn`]);

    return data;
}

export const columns = (onChange, date, print) => {
    const year = moment(date).format('YYYY');
    const month = moment(date).format('M');
    const sqlName = '_4_2_1_new';
    let key = [];
    if (process.env.NODE_ENV === "development") key = [{
        title: "Index",
        dataIndex: 'index',
        key: 'index',
        align: "center",
        fixed: print ? false : "left",
        width: 50,
        render: (text, record, index) => {
            const props = {
                text: `${index}`,
                index,
                type: 'text',
                name: "index",
                onChange,
                totalIndex,
            };
            return <TableText data={props} />
        }
    }];
    return [
        ...key,
        {
            title: year,
            dataIndex: 'name',
            key: 'name',
            align: "center",
            fixed: print ? false : "left",
            width: 300,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'text',
                    name: "name",
                    onChange,
                    totalIndex,
                    compared: {
                        title: ['name'],
                        record,
                        sqlName
                    }
                };
                return <TableText data={props} />
            }
        },
        ...nameKeyLst.map((x, i) => {
            return {
                title: `FULL MONTH`,
                align: "center",
                width: 450,
                children: [{
                    title: x.name,
                    align: "center",
                    width: 450,
                    children: [{
                        title: x.key.includes('mix') ? "TYA" : "RNs",
                        dataIndex: `${x.key}_rn`,
                        key: `${x.key}_rn`,
                        width: 150,
                        align: "center",
                        render: (text, record, index) => {
                            const title = ["FULL MONTH", x.name, x.key.includes('mix') ? "TYA" : "RNs"];
                            const props = {
                                text,
                                index,
                                type: [31, 32].includes(index) ? '' : month == 1 && x.key == 'forecast' && ![...totalIndex, 36].includes(index) && !print ? 'inputNumber' : percentIndex.includes(index) || x.key.includes('mix') ? 'percent' : "number",
                                name: `${x.key}_rn`,
                                onChange,
                                totalIndex,
                            };
                            props.compared = {
                                title,
                                record,
                                sqlName
                            };
                            return <TableText data={props} />
                        }
                    }, {
                        title: x.key.includes('mix') ? "LYA" : "ADR",
                        dataIndex: `${x.key}_adr`,
                        key: `${x.key}_adr`,
                        width: 150,
                        align: "center",
                        render: (text, record, index) => {
                            const title = ["FULL MONTH", x.name, x.key.includes('mix') ? "LYA" : "ADR"];
                            const props = {
                                text,
                                index,
                                type: [29, 30, 31, 32, 35].includes(index) ? '' : x.key.includes('mix') ? 'percent' : "number",
                                name: `${x.key}_adr`,
                                onChange,
                                totalIndex,
                            };
                            props.compared = {
                                title,
                                record,
                                sqlName
                            };
                            return <TableText data={props} />
                        }
                    }, {
                        title: x.key.includes('mix') ? "BDGT" : "REVENUE",
                        dataIndex: `${x.key}_rev`,
                        key: `${x.key}_rev`,
                        width: 150,
                        align: "center",
                        render: (text, record, index) => {
                            const title = ["FULL MONTH", x.name, x.key.includes('mix') ? "BDGT" : 'REVENUE'];
                            const props = {
                                text,
                                index,
                                type: [29, 30, 35].includes(index) ? '' : month == 1 && x.key == 'forecast' && ![...totalIndex, 36].includes(index) && !print ? 'inputNumber' : x.key.includes('mix') ? 'percent' : "number",
                                name: `${x.key}_rev`,
                                onChange,
                                totalIndex,
                            };
                            props.compared = {
                                title,
                                record,
                                sqlName
                            };
                            return <TableText data={props} />
                        }
                    }]
                }],

            }
        })
    ]
}


// WEBPACK FOOTER //
// ./src/components/table/4new/4.2/4.2.1/compute.js